/**
 * App — NRR & CX Diagnostic.
 * Loads the bespoke client config and renders the dashboard directly.
 * No setup form — all client data is baked into client-config.json
 * by the LLM during the Cursor-driven research phase.
 */

import { useEffect, useState } from "react";
import type { ClientConfig } from "./types/diagnostic";
import { loadClientConfig } from "./lib/config";
import { DiagnosticDashboard } from "./components/DiagnosticDashboard";

function App() {
  const [config, setConfig] = useState<ClientConfig | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadClientConfig()
      .then(setConfig)
      .catch((err) => setError(err.message));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-surface-secondary flex items-center justify-center p-6">
        <div className="mck-card-elevated p-8 max-w-md text-center">
          <h1 className="text-xl font-semibold text-text-primary mb-3">
            No Diagnostic Configured
          </h1>
          <p className="text-sm text-text-secondary mb-4">{error}</p>
          <p className="text-xs text-text-tertiary">
            Run the diagnostic from Cursor chat first: say{" "}
            <code className="bg-surface-tertiary px-1.5 py-0.5 rounded text-text-secondary">
              Run diagnostic for [ClientName]
            </code>{" "}
            to generate the client config.
          </p>
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="min-h-screen bg-surface-secondary flex items-center justify-center">
        <p className="text-text-secondary">Loading diagnostic...</p>
      </div>
    );
  }

  return <DiagnosticDashboard config={config} />;
}

export default App;
